import AtomsBreakline from "../atoms/AtomsBreakline"
import AtomsButton from "../atoms/AtomsButton"
import AtomsText from "../atoms/AtomsText"


const OrganismsWelcome = (props) => {
    const sendEmail = () => {
        const email = 'flazen.edu@gmail.com'
        const subject = 'FlazenApps Visitor'
        const body = `Hello Leo, It's Me ..., I want to request access for your apps`

        const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
        window.location.href = mailtoLink
    }

    return (
        <div className="welcome-box">
            <AtomsBreakline length={3}/>
            <AtomsText type='main-title' class='text-dark' text="Welcome, to FlazenApps"/>
            <AtomsText type='main-title' class='text-dark' text="Here you can find Leo's random apps"/>
            <AtomsBreakline length={2}/>
            <hr style={{color:"var(--darkColor)"}}></hr>
            <AtomsBreakline length={1}/>
            <AtomsText type='subtitle-second' class='text-white mb-3' text={<>Contact me If you want to get access to <b className="text-dark">"All in One Account"</b></>}/>
            <AtomsButton class='btn-danger btn-full-mobile' text='Request Access' action={sendEmail}/>
            <AtomsBreakline length={2}/>
            <AtomsText type='subtitle-second' class='text-white mb-3' text={<>Or, do you wanna try to read the docs first? <AtomsButton class='btn-tag' text='Docs & Presentation'/></>}/>
            <AtomsBreakline length={3}/>
        </div>
    )
}
  
export default OrganismsWelcome
